{
  "nsw-grey": {
    "50": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.985104,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#fafafa"
      }
    },
    "100": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.970151,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#f5f5f5"
      }
    },
    "150": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.95514,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#f0f0f0"
      }
    },
    "200": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.94007,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#ebebeb"
      }
    },
    "250": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.920652,
          0.002558,
          228.786818
        ],
        "alpha": 1,
        "hex": "#e3e5e6"
      }
    },
    "300": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.901624,
          0.003538,
          219.535738
        ],
        "alpha": 1,
        "hex": "#dcdfe0"
      }
    },
    "350": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.882025,
          0.006111,
          223.464254
        ],
        "alpha": 1,
        "hex": "#d4d9db"
      }
    },
    "400": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.863097,
          0.007776,
          228.868893
        ],
        "alpha": 1,
        "hex": "#cdd3d6"
      }
    },
    "450": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.753634,
          0.008885,
          236.605307
        ],
        "alpha": 1,
        "hex": "#aab0b4"
      }
    },
    "500": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.645222,
          0.009348,
          225.150438
        ],
        "alpha": 1,
        "hex": "#888f92"
      }
    },
    "550": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.536704,
          0.009767,
          225.197358
        ],
        "alpha": 1,
        "hex": "#686f72"
      }
    },
    "600": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.426427,
          0.011202,
          232.617199
        ],
        "alpha": 1,
        "hex": "#495054"
      }
    },
    "650": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.386365,
          0.01045,
          236.835687
        ],
        "alpha": 1,
        "hex": "#3f4549"
      }
    },
    "700": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.348204,
          0.010712,
          236.894097
        ],
        "alpha": 1,
        "hex": "#353b3f"
      }
    },
    "750": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.308978,
          0.011017,
          236.97265
        ],
        "alpha": 1,
        "hex": "#2b3135"
      }
    },
    "800": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.269413,
          0.01036,
          242.083865
        ],
        "alpha": 1,
        "hex": "#22272b"
      }
    },
    "850": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.223572,
          0.008405,
          240.274391
        ],
        "alpha": 1,
        "hex": "#181c1f"
      }
    },
    "900": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.175228,
          0.006346,
          236.981786
        ],
        "alpha": 1,
        "hex": "#0e1113"
      }
    },
    "950": {
      "$type": "color",
      "$description": "Neutral grey — text, borders, surfaces, and dividers; every theme’s grey ramp aliases this family. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.126543,
          0.006953,
          243.792325
        ],
        "alpha": 1,
        "hex": "#050709"
      }
    }
  },
  "nsw-green": {
    "50": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.990081,
          0.015795,
          148.41438
        ],
        "alpha": 1,
        "hex": "#f5fff6"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.977431,
          0.026606,
          148.839664
        ],
        "alpha": 1,
        "hex": "#ecfdee"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.967911,
          0.037416,
          148.930338
        ],
        "alpha": 1,
        "hex": "#e4fce7"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.955545,
          0.04826,
          148.904545
        ],
        "alpha": 1,
        "hex": "#dbfadf"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.93851,
          0.062505,
          148.569017
        ],
        "alpha": 1,
        "hex": "#cff7d4"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.921117,
          0.077402,
          148.783229
        ],
        "alpha": 1,
        "hex": "#c2f4c9"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.901882,
          0.090617,
          148.915542
        ],
        "alpha": 1,
        "hex": "#b5f0be"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.885183,
          0.105294,
          148.825537
        ],
        "alpha": 1,
        "hex": "#a8edb3"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.824352,
          0.124607,
          148.589905
        ],
        "alpha": 1,
        "hex": "#8adc98"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.765718,
          0.145713,
          148.416765
        ],
        "alpha": 1,
        "hex": "#6acc7d"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.704641,
          0.16526,
          148.484663
        ],
        "alpha": 1,
        "hex": "#45bb62"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.643827,
          0.185071,
          148.266392
        ],
        "alpha": 1,
        "hex": "#00aa45"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.563991,
          0.166488,
          146.780194
        ],
        "alpha": 1,
        "hex": "#078e32"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.484,
          0.147861,
          145.298202
        ],
        "alpha": 1,
        "hex": "#077320"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.403409,
          0.12884,
          143.996921
        ],
        "alpha": 1,
        "hex": "#03590f"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.321878,
          0.109527,
          142.495345
        ],
        "alpha": 1,
        "hex": "#004000"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.267891,
          0.091156,
          142.495345
        ],
        "alpha": 1,
        "hex": "#003000"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.211008,
          0.071801,
          142.495345
        ],
        "alpha": 1,
        "hex": "#002000"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW palette green — accents, illustration, and data-visualisation support (semantic success states use the dedicated success ramp). Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.153912,
          0.052372,
          142.495345
        ],
        "alpha": 1,
        "hex": "#001100"
      }
    }
  },
  "nsw-teal": {
    "50": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.981084,
          0.009583,
          189.068864
        ],
        "alpha": 1,
        "hex": "#f2fbfa"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.963745,
          0.017041,
          187.89812
        ],
        "alpha": 1,
        "hex": "#e7f7f5"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.944172,
          0.023457,
          186.915975
        ],
        "alpha": 1,
        "hex": "#dcf2ef"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.926969,
          0.030829,
          186.587966
        ],
        "alpha": 1,
        "hex": "#d1eeea"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.907198,
          0.04267,
          190.957151
        ],
        "alpha": 1,
        "hex": "#c1eae7"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.884847,
          0.055135,
          196.19898
        ],
        "alpha": 1,
        "hex": "#afe5e5"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.864304,
          0.066593,
          201.943435
        ],
        "alpha": 1,
        "hex": "#9ee0e5"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.843907,
          0.078713,
          205.971232
        ],
        "alpha": 1,
        "hex": "#8cdbe5"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.773472,
          0.079248,
          207.069585
        ],
        "alpha": 1,
        "hex": "#75c4cf"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.699402,
          0.079119,
          209.446408
        ],
        "alpha": 1,
        "hex": "#5eacb9"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.628309,
          0.080069,
          209.493158
        ],
        "alpha": 1,
        "hex": "#4696a3"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.55658,
          0.080187,
          210.887635
        ],
        "alpha": 1,
        "hex": "#2e808e"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.501916,
          0.073272,
          210.257312
        ],
        "alpha": 1,
        "hex": "#256f7b"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.448897,
          0.066803,
          209.287131
        ],
        "alpha": 1,
        "hex": "#1c5f69"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.392261,
          0.059727,
          211.556304
        ],
        "alpha": 1,
        "hex": "#144e58"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.339119,
          0.053288,
          210.303482
        ],
        "alpha": 1,
        "hex": "#0b3f47"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.28054,
          0.045497,
          209.000284
        ],
        "alpha": 1,
        "hex": "#042f35"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.219761,
          0.036868,
          210.291523
        ],
        "alpha": 1,
        "hex": "#011f24"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW palette teal — accents, illustration, and data-visualisation support. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.162471,
          0.027924,
          207.933306
        ],
        "alpha": 1,
        "hex": "#001114"
      }
    }
  },
  "nsw-blue": {
    "50": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.981046,
          0.012805,
          221.42319
        ],
        "alpha": 1,
        "hex": "#f0fbff"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.962528,
          0.022535,
          229.073806
        ],
        "alpha": 1,
        "hex": "#e4f6ff"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.945178,
          0.032646,
          226.304274
        ],
        "alpha": 1,
        "hex": "#d7f2fe"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.926674,
          0.041663,
          227.890787
        ],
        "alpha": 1,
        "hex": "#cbedfd"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.911263,
          0.054737,
          226.223779
        ],
        "alpha": 1,
        "hex": "#bceafe"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.896395,
          0.067447,
          225.364647
        ],
        "alpha": 1,
        "hex": "#ade7ff"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.87908,
          0.079726,
          224.961348
        ],
        "alpha": 1,
        "hex": "#9de3ff"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.864091,
          0.092143,
          223.595164
        ],
        "alpha": 1,
        "hex": "#8ce0ff"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.793049,
          0.126377,
          232.671182
        ],
        "alpha": 1,
        "hex": "#5ac9ff"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.719588,
          0.160232,
          241.934243
        ],
        "alpha": 1,
        "hex": "#26aeff"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.647121,
          0.194114,
          252.085254
        ],
        "alpha": 1,
        "hex": "#008fff"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.575113,
          0.229834,
          260.756335
        ],
        "alpha": 1,
        "hex": "#146cfd"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.504429,
          0.200565,
          260.409998
        ],
        "alpha": 1,
        "hex": "#0c5ad4"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.433012,
          0.172764,
          260.164397
        ],
        "alpha": 1,
        "hex": "#0548ad"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.360675,
          0.146274,
          260.290439
        ],
        "alpha": 1,
        "hex": "#023688"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.289999,
          0.117296,
          259.841938
        ],
        "alpha": 1,
        "hex": "#002664"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.238584,
          0.100105,
          260.505764
        ],
        "alpha": 1,
        "hex": "#001a4d"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.190403,
          0.080719,
          260.682766
        ],
        "alpha": 1,
        "hex": "#001037"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW brand blue — masterbrand primary aliases this ramp (primary actions, links, key accents); fuchsia-blue accent also draws from it. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.138623,
          0.062732,
          261.699127
        ],
        "alpha": 1,
        "hex": "#000622"
      }
    }
  },
  "nsw-purple": {
    "50": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.979942,
          0.010771,
          297.629538
        ],
        "alpha": 1,
        "hex": "#f9f7ff"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.96104,
          0.020078,
          292.148399
        ],
        "alpha": 1,
        "hex": "#f2f0ff"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.940643,
          0.02976,
          294.163862
        ],
        "alpha": 1,
        "hex": "#ece8fe"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.922152,
          0.038089,
          293.832311
        ],
        "alpha": 1,
        "hex": "#e6e1fd"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.902386,
          0.050699,
          294.035459
        ],
        "alpha": 1,
        "hex": "#e0d9fe"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.880403,
          0.063609,
          295.026076
        ],
        "alpha": 1,
        "hex": "#dad0fe"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.860749,
          0.07647,
          294.744797
        ],
        "alpha": 1,
        "hex": "#d4c8ff"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.838898,
          0.089613,
          295.149512
        ],
        "alpha": 1,
        "hex": "#cebfff"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.774614,
          0.122118,
          294.042831
        ],
        "alpha": 1,
        "hex": "#baa6fc"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.711084,
          0.154805,
          292.674319
        ],
        "alpha": 1,
        "hex": "#a68df9"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.646097,
          0.188334,
          291.878793
        ],
        "alpha": 1,
        "hex": "#9372f5"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.58173,
          0.221615,
          290.501683
        ],
        "alpha": 1,
        "hex": "#8055f1"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.516922,
          0.203649,
          293.377615
        ],
        "alpha": 1,
        "hex": "#7243cf"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.453186,
          0.185326,
          296.711408
        ],
        "alpha": 1,
        "hex": "#6432ae"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.386977,
          0.16729,
          299.692934
        ],
        "alpha": 1,
        "hex": "#54218e"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.322758,
          0.148913,
          302.732273
        ],
        "alpha": 1,
        "hex": "#441170"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.265767,
          0.126298,
          303.073254
        ],
        "alpha": 1,
        "hex": "#330856"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.20962,
          0.104671,
          303.28248
        ],
        "alpha": 1,
        "hex": "#23023e"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW palette purple — accents, illustration, and data-visualisation support. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.152833,
          0.080653,
          302.075394
        ],
        "alpha": 1,
        "hex": "#130027"
      }
    }
  },
  "nsw-fuchsia": {
    "50": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.982084,
          0.013244,
          333.034319
        ],
        "alpha": 1,
        "hex": "#fff6fd"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.965669,
          0.023247,
          338.610142
        ],
        "alpha": 1,
        "hex": "#ffeef9"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.948854,
          0.03339,
          337.959274
        ],
        "alpha": 1,
        "hex": "#fee6f6"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.93185,
          0.042831,
          339.134147
        ],
        "alpha": 1,
        "hex": "#fddef2"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.910705,
          0.055741,
          337.314857
        ],
        "alpha": 1,
        "hex": "#fbd4ef"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.887629,
          0.069703,
          336.916306
        ],
        "alpha": 1,
        "hex": "#f9c9eb"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.86725,
          0.08373,
          335.420133
        ],
        "alpha": 1,
        "hex": "#f7bfe9"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.84582,
          0.096185,
          334.510766
        ],
        "alpha": 1,
        "hex": "#f4b5e6"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.784752,
          0.136018,
          335.952916
        ],
        "alpha": 1,
        "hex": "#ef96da"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.723334,
          0.175513,
          337.649945
        ],
        "alpha": 1,
        "hex": "#e975cc"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.661983,
          0.214363,
          338.632544
        ],
        "alpha": 1,
        "hex": "#e150be"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.601253,
          0.254233,
          340.252307
        ],
        "alpha": 1,
        "hex": "#d912ae"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.536642,
          0.227232,
          340.78992
        ],
        "alpha": 1,
        "hex": "#bb0c94"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.470462,
          0.200119,
          341.098388
        ],
        "alpha": 1,
        "hex": "#9d067b"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.406687,
          0.174181,
          341.335872
        ],
        "alpha": 1,
        "hex": "#810264"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.340576,
          0.146851,
          341.706145
        ],
        "alpha": 1,
        "hex": "#65004d"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.282424,
          0.121774,
          341.71207
        ],
        "alpha": 1,
        "hex": "#4d003a"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.22599,
          0.097183,
          342.322886
        ],
        "alpha": 1,
        "hex": "#370028"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW brand fuchsia — the primary ramp for the fuchsia-blue and fuchsia-orange themes. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.168705,
          0.072287,
          343.166627
        ],
        "alpha": 1,
        "hex": "#220017"
      }
    }
  },
  "nsw-red": {
    "50": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.984801,
          0.007587,
          7.280361
        ],
        "alpha": 1,
        "hex": "#fff8f9"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.97188,
          0.014232,
          6.700043
        ],
        "alpha": 1,
        "hex": "#fff2f4"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.959029,
          0.020979,
          6.606185
        ],
        "alpha": 1,
        "hex": "#ffecef"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.946252,
          0.027827,
          6.653086
        ],
        "alpha": 1,
        "hex": "#ffe6ea"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.922815,
          0.040479,
          8.438397
        ],
        "alpha": 1,
        "hex": "#ffdbe0"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.897868,
          0.054828,
          8.39461
        ],
        "alpha": 1,
        "hex": "#ffcfd6"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.875166,
          0.068164,
          9.494436
        ],
        "alpha": 1,
        "hex": "#ffc4cc"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.850883,
          0.08303,
          10.570683
        ],
        "alpha": 1,
        "hex": "#ffb8c1"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.779076,
          0.116944,
          12.810782
        ],
        "alpha": 1,
        "hex": "#f897a2"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.707215,
          0.150378,
          15.602977
        ],
        "alpha": 1,
        "hex": "#ef7581"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.634722,
          0.184087,
          17.935378
        ],
        "alpha": 1,
        "hex": "#e44f5f"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.561955,
          0.217505,
          20.33356
        ],
        "alpha": 1,
        "hex": "#d7153a"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.501611,
          0.19526,
          19.649998
        ],
        "alpha": 1,
        "hex": "#b90e32"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.439441,
          0.172351,
          18.724983
        ],
        "alpha": 1,
        "hex": "#9b072a"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.377602,
          0.149006,
          17.706488
        ],
        "alpha": 1,
        "hex": "#7e0322"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.316967,
          0.126887,
          17.133117
        ],
        "alpha": 1,
        "hex": "#630019"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.26401,
          0.105766,
          17.967115
        ],
        "alpha": 1,
        "hex": "#4c0010"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.210832,
          0.084535,
          18.772606
        ],
        "alpha": 1,
        "hex": "#360008"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW brand red — masterbrand accent aliases this ramp (secondary emphasis and highlights; distinct from the semantic danger ramp). Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.156795,
          0.062933,
          19.607624
        ],
        "alpha": 1,
        "hex": "#210003"
      }
    }
  },
  "nsw-orange": {
    "50": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.987839,
          0.007543,
          61.45578
        ],
        "alpha": 1,
        "hex": "#fffaf6"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.977951,
          0.014375,
          64.347922
        ],
        "alpha": 1,
        "hex": "#fff6ee"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.965645,
          0.019381,
          60.174704
        ],
        "alpha": 1,
        "hex": "#fef1e7"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.955039,
          0.025491,
          63.743337
        ],
        "alpha": 1,
        "hex": "#fdeddf"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.936249,
          0.041053,
          64.929124
        ],
        "alpha": 1,
        "hex": "#fee5ce"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.917859,
          0.056636,
          65.300646
        ],
        "alpha": 1,
        "hex": "#ffddbd"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.900675,
          0.072472,
          68.034989
        ],
        "alpha": 1,
        "hex": "#ffd6ab"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.882019,
          0.087884,
          68.490482
        ],
        "alpha": 1,
        "hex": "#ffce99"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.829842,
          0.113933,
          61.388359
        ],
        "alpha": 1,
        "hex": "#fdb678"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.778954,
          0.140471,
          55.166517
        ],
        "alpha": 1,
        "hex": "#fb9d58"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.72492,
          0.166374,
          48.688783
        ],
        "alpha": 1,
        "hex": "#f78139"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.674414,
          0.192429,
          42.148083
        ],
        "alpha": 1,
        "hex": "#f3631b"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.613962,
          0.184358,
          39.794614
        ],
        "alpha": 1,
        "hex": "#db5115"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.55289,
          0.176309,
          37.423321
        ],
        "alpha": 1,
        "hex": "#c33f0e"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.492464,
          0.16713,
          35.422254
        ],
        "alpha": 1,
        "hex": "#ab2e06"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.432199,
          0.159379,
          33.02244
        ],
        "alpha": 1,
        "hex": "#941b00"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.357475,
          0.135212,
          32.07107
        ],
        "alpha": 1,
        "hex": "#730f00"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.281222,
          0.110671,
          30.651366
        ],
        "alpha": 1,
        "hex": "#530400"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW palette orange — fuchsia-orange accent aliases this ramp; warm accents and illustration. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.206578,
          0.08477,
          29.23388
        ],
        "alpha": 1,
        "hex": "#350000"
      }
    }
  },
  "nsw-yellow": {
    "50": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.990123,
          0.016076,
          95.219322
        ],
        "alpha": 1,
        "hex": "#fffcf0"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.983411,
          0.027978,
          95.885149
        ],
        "alpha": 1,
        "hex": "#fffae5"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.974866,
          0.038751,
          94.277708
        ],
        "alpha": 1,
        "hex": "#fff7da"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.96644,
          0.049432,
          93.383449
        ],
        "alpha": 1,
        "hex": "#fff4cf"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.957711,
          0.06238,
          93.425567
        ],
        "alpha": 1,
        "hex": "#fff1c2"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.948327,
          0.074821,
          94.273041
        ],
        "alpha": 1,
        "hex": "#feeeb5"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.937977,
          0.086258,
          93.231211
        ],
        "alpha": 1,
        "hex": "#feeaa8"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.928754,
          0.099044,
          94.038586
        ],
        "alpha": 1,
        "hex": "#fde79a"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.897354,
          0.115545,
          89.863426
        ],
        "alpha": 1,
        "hex": "#fbda80"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.867379,
          0.133527,
          86.293084
        ],
        "alpha": 1,
        "hex": "#facd63"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.835549,
          0.15046,
          81.626951
        ],
        "alpha": 1,
        "hex": "#fabe42"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.805038,
          0.167358,
          77.590601
        ],
        "alpha": 1,
        "hex": "#faaf05"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.71131,
          0.147875,
          77.735972
        ],
        "alpha": 1,
        "hex": "#d49403"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.617531,
          0.128406,
          78.181686
        ],
        "alpha": 1,
        "hex": "#af7a01"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.521285,
          0.108602,
          78.157346
        ],
        "alpha": 1,
        "hex": "#8b6000"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.427326,
          0.08887,
          78.678822
        ],
        "alpha": 1,
        "hex": "#694800"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.351758,
          0.07351,
          77.298566
        ],
        "alpha": 1,
        "hex": "#503500"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.279606,
          0.058706,
          76.10848
        ],
        "alpha": 1,
        "hex": "#392400"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW palette yellow — accents, illustration, and data-visualisation support (semantic warning states use the dedicated warning ramp). Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.202409,
          0.042946,
          73.773854
        ],
        "alpha": 1,
        "hex": "#221300"
      }
    }
  },
  "nsw-brown": {
    "50": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.980322,
          0.006204,
          75.407199
        ],
        "alpha": 1,
        "hex": "#fbf8f4"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.96009,
          0.010761,
          76.598329
        ],
        "alpha": 1,
        "hex": "#f6f1ea"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.940844,
          0.014842,
          70.884167
        ],
        "alpha": 1,
        "hex": "#f2eae1"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.92047,
          0.019451,
          72.565423
        ],
        "alpha": 1,
        "hex": "#ede3d7"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.907511,
          0.026415,
          71.174552
        ],
        "alpha": 1,
        "hex": "#ecdece"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.895976,
          0.032101,
          73.507317
        ],
        "alpha": 1,
        "hex": "#eadac6"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.883104,
          0.039083,
          72.324463
        ],
        "alpha": 1,
        "hex": "#e9d5bd"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.87053,
          0.045049,
          70.467357
        ],
        "alpha": 1,
        "hex": "#e8d0b5"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.820425,
          0.053636,
          70.701121
        ],
        "alpha": 1,
        "hex": "#dbbf9f"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.770788,
          0.063048,
          69.882833
        ],
        "alpha": 1,
        "hex": "#cfae89"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.719766,
          0.071814,
          69.840337
        ],
        "alpha": 1,
        "hex": "#c29d73"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.671378,
          0.081345,
          70.110363
        ],
        "alpha": 1,
        "hex": "#b68d5d"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.593487,
          0.075855,
          68.942252
        ],
        "alpha": 1,
        "hex": "#9c764b"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.515306,
          0.06944,
          68.344793
        ],
        "alpha": 1,
        "hex": "#82603a"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.438779,
          0.064545,
          67.310247
        ],
        "alpha": 1,
        "hex": "#6a4b29"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.361361,
          0.058506,
          66.920145
        ],
        "alpha": 1,
        "hex": "#523719"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.298054,
          0.050193,
          67.139028
        ],
        "alpha": 1,
        "hex": "#3e280f"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.235424,
          0.040856,
          66.793394
        ],
        "alpha": 1,
        "hex": "#2b1a07"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW palette brown — accents, illustration, and data-visualisation support. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.172585,
          0.031824,
          67.984068
        ],
        "alpha": 1,
        "hex": "#190d02"
      }
    }
  },
  "nsw-aboriginal-grey": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.979613,
          0.001708,
          67.802154
        ],
        "alpha": 1,
        "hex": "#f9f8f7"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.958355,
          0.002875,
          84.559036
        ],
        "alpha": 1,
        "hex": "#f2f1ef"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.937258,
          0.002891,
          84.559255
        ],
        "alpha": 1,
        "hex": "#ebeae8"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Smoke Grey. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.916542,
          0.004595,
          78.296868
        ],
        "alpha": 1,
        "hex": "#e5e3e0"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.895714,
          0.006344,
          75.402785
        ],
        "alpha": 1,
        "hex": "#dfdcd8"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.872255,
          0.006037,
          59.639958
        ],
        "alpha": 1,
        "hex": "#d8d4d1"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.851173,
          0.007831,
          61.434716
        ],
        "alpha": 1,
        "hex": "#d2cdc9"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Ash Grey. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.830249,
          0.008721,
          56.288523
        ],
        "alpha": 1,
        "hex": "#ccc6c2"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.734858,
          0.007201,
          53.408349
        ],
        "alpha": 1,
        "hex": "#ada8a5"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.639018,
          0.003881,
          39.468326
        ],
        "alpha": 1,
        "hex": "#8e8b8a"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.545732,
          0.001977,
          67.781807
        ],
        "alpha": 1,
        "hex": "#71706f"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Emu Grey. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.449533,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#555555"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.405398,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#494949"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.360023,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#3d3d3d"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.317136,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#323232"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Charcoal Grey. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.272741,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#272727"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.22645,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#1c1c1c"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.177638,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#111111"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette grey. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.128558,
          0,
          "none"
        ],
        "alpha": 1,
        "hex": "#070707"
      }
    }
  },
  "nsw-aboriginal-red": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.977917,
          0.01075,
          17.340194
        ],
        "alpha": 1,
        "hex": "#fff5f5"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.956021,
          0.021805,
          17.540209
        ],
        "alpha": 1,
        "hex": "#ffebeb"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.935641,
          0.030896,
          17.717103
        ],
        "alpha": 1,
        "hex": "#fee2e2"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Galah Pink. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.915394,
          0.0402,
          17.910042
        ],
        "alpha": 1,
        "hex": "#fdd9d9"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.896228,
          0.050863,
          18.143256
        ],
        "alpha": 1,
        "hex": "#fdd0d0"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.876091,
          0.060658,
          19.635877
        ],
        "alpha": 1,
        "hex": "#fcc7c6"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.855637,
          0.072943,
          18.685192
        ],
        "alpha": 1,
        "hex": "#fcbdbd"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Coral Pink. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.836037,
          0.083154,
          19.887576
        ],
        "alpha": 1,
        "hex": "#fbb4b3"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.772599,
          0.117401,
          22.034576
        ],
        "alpha": 1,
        "hex": "#f79693"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.710749,
          0.152503,
          24.524635
        ],
        "alpha": 1,
        "hex": "#f27771"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.64772,
          0.185981,
          26.992016
        ],
        "alpha": 1,
        "hex": "#ea554c"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Ember Red. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.585456,
          0.220516,
          29.136139
        ],
        "alpha": 1,
        "hex": "#e1261c"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.544312,
          0.207167,
          29.033171
        ],
        "alpha": 1,
        "hex": "#cd1f17"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.504372,
          0.19444,
          29.090046
        ],
        "alpha": 1,
        "hex": "#ba1811"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.463857,
          0.181292,
          29.151502
        ],
        "alpha": 1,
        "hex": "#a7110b"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Earth Red. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.42441,
          0.168832,
          29.059253
        ],
        "alpha": 1,
        "hex": "#950906"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.351087,
          0.14392,
          28.917784
        ],
        "alpha": 1,
        "hex": "#740001"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.280004,
          0.1149,
          29.23388
        ],
        "alpha": 1,
        "hex": "#540000"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette red. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.20904,
          0.08578,
          29.23388
        ],
        "alpha": 1,
        "hex": "#360000"
      }
    }
  },
  "nsw-aboriginal-orange": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.973556,
          0.015952,
          58.641276
        ],
        "alpha": 1,
        "hex": "#fff4ec"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.947654,
          0.028075,
          51.846173
        ],
        "alpha": 1,
        "hex": "#fee9dd"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.922782,
          0.040228,
          53.880344
        ],
        "alpha": 1,
        "hex": "#fcdfcd"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Sunset Orange. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.895542,
          0.051085,
          52.555439
        ],
        "alpha": 1,
        "hex": "#f9d4be"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.872031,
          0.064527,
          52.950639
        ],
        "alpha": 1,
        "hex": "#f8caae"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.84704,
          0.078423,
          51.844811
        ],
        "alpha": 1,
        "hex": "#f7bf9e"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.824377,
          0.092099,
          52.01177
        ],
        "alpha": 1,
        "hex": "#f6b58e"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Clay Orange. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.799158,
          0.105847,
          51.972937
        ],
        "alpha": 1,
        "hex": "#f4aa7d"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.766094,
          0.126491,
          50.281467
        ],
        "alpha": 1,
        "hex": "#f39a66"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.733244,
          0.147307,
          48.030411
        ],
        "alpha": 1,
        "hex": "#f2894f"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.699805,
          0.167547,
          45.94896
        ],
        "alpha": 1,
        "hex": "#f07736"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Orange Ochre. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.666534,
          0.188575,
          43.59666
        ],
        "alpha": 1,
        "hex": "#ee6314"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.605157,
          0.176427,
          41.984292
        ],
        "alpha": 1,
        "hex": "#d45310"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.543706,
          0.163519,
          40.722838
        ],
        "alpha": 1,
        "hex": "#ba440a"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.482528,
          0.151339,
          39.057361
        ],
        "alpha": 1,
        "hex": "#a13505"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Deep Orange. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.419873,
          0.139043,
          37.476491
        ],
        "alpha": 1,
        "hex": "#882600"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.346307,
          0.117509,
          36.402344
        ],
        "alpha": 1,
        "hex": "#691900"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.274179,
          0.096195,
          34.994332
        ],
        "alpha": 1,
        "hex": "#4c0d00"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette orange. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.19945,
          0.074821,
          32.376266
        ],
        "alpha": 1,
        "hex": "#300300"
      }
    }
  },
  "nsw-aboriginal-brown": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.964567,
          0.015989,
          58.638621
        ],
        "alpha": 1,
        "hex": "#fcf1e9"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.927872,
          0.026411,
          54.553798
        ],
        "alpha": 1,
        "hex": "#f6e3d7"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.890008,
          0.037066,
          55.325516
        ],
        "alpha": 1,
        "hex": "#efd5c4"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Macadamia Brown. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.855158,
          0.047928,
          55.657964
        ],
        "alpha": 1,
        "hex": "#e9c8b2"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.819152,
          0.060928,
          54.401987
        ],
        "alpha": 1,
        "hex": "#e4ba9f"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.78428,
          0.072995,
          55.357845
        ],
        "alpha": 1,
        "hex": "#dead8c"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.748613,
          0.08714,
          54.877732
        ],
        "alpha": 1,
        "hex": "#d99f78"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Claystone Brown. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.712508,
          0.099636,
          54.125312
        ],
        "alpha": 1,
        "hex": "#d39165"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.665756,
          0.102275,
          50.954073
        ],
        "alpha": 1,
        "hex": "#c68158"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.620455,
          0.1048,
          48.79466
        ],
        "alpha": 1,
        "hex": "#b9724b"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.57171,
          0.107229,
          46.104324
        ],
        "alpha": 1,
        "hex": "#ab623e"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Firewood Brown. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.525934,
          0.109911,
          43.512384
        ],
        "alpha": 1,
        "hex": "#9e5332"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.474445,
          0.103738,
          43.660091
        ],
        "alpha": 1,
        "hex": "#8b4627"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.423254,
          0.098571,
          43.417081
        ],
        "alpha": 1,
        "hex": "#79391c"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.372414,
          0.092596,
          44.367772
        ],
        "alpha": 1,
        "hex": "#672d10"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Riverbed Brown. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.320219,
          0.085938,
          44.68528
        ],
        "alpha": 1,
        "hex": "#552105"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.264623,
          0.073691,
          43.721344
        ],
        "alpha": 1,
        "hex": "#411602"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.207747,
          0.060107,
          44.309952
        ],
        "alpha": 1,
        "hex": "#2d0c00"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette brown. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.152266,
          0.046833,
          41.010251
        ],
        "alpha": 1,
        "hex": "#1b0400"
      }
    }
  },
  "nsw-aboriginal-yellow": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.989602,
          0.018635,
          96.856306
        ],
        "alpha": 1,
        "hex": "#fffcee"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.978269,
          0.032246,
          93.512682
        ],
        "alpha": 1,
        "hex": "#fff8e0"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.969312,
          0.045474,
          93.502046
        ],
        "alpha": 1,
        "hex": "#fff5d3"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Sunbeam Yellow. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.95835,
          0.058779,
          92.480032
        ],
        "alpha": 1,
        "hex": "#fff1c5"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.949558,
          0.072703,
          92.938598
        ],
        "alpha": 1,
        "hex": "#ffeeb7"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.940981,
          0.086217,
          93.231463
        ],
        "alpha": 1,
        "hex": "#ffeba9"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.929786,
          0.098167,
          93.219492
        ],
        "alpha": 1,
        "hex": "#fee79b"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Golden Wattle Yellow. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.921488,
          0.111616,
          93.481979
        ],
        "alpha": 1,
        "hex": "#fee48c"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.890835,
          0.124269,
          87.387746
        ],
        "alpha": 1,
        "hex": "#fed675"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.861059,
          0.137541,
          82.135219
        ],
        "alpha": 1,
        "hex": "#fec85d"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.830545,
          0.150151,
          76.680641
        ],
        "alpha": 1,
        "hex": "#feb944"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Sandstone Yellow. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.799616,
          0.162605,
          70.976799
        ],
        "alpha": 1,
        "hex": "#fea927"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.728511,
          0.148735,
          72.818047
        ],
        "alpha": 1,
        "hex": "#df961c"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.656941,
          0.134714,
          74.492339
        ],
        "alpha": 1,
        "hex": "#c18312"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.585858,
          0.121453,
          75.52775
        ],
        "alpha": 1,
        "hex": "#a57007"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Bush Honey Yellow. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.514668,
          0.107421,
          77.638623
        ],
        "alpha": 1,
        "hex": "#895e00"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.425162,
          0.088781,
          77.508419
        ],
        "alpha": 1,
        "hex": "#694700"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.33488,
          0.07099,
          73.957757
        ],
        "alpha": 1,
        "hex": "#4c3000"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette yellow. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.245313,
          0.052014,
          73.912488
        ],
        "alpha": 1,
        "hex": "#2f1c00"
      }
    }
  },
  "nsw-aboriginal-green": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.977165,
          0.010132,
          131.357222
        ],
        "alpha": 1,
        "hex": "#f5f9f2"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.955574,
          0.01752,
          131.874777
        ],
        "alpha": 1,
        "hex": "#ecf3e7"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.931904,
          0.023343,
          131.148975
        ],
        "alpha": 1,
        "hex": "#e3ecdc"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Saltbush Green. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.91016,
          0.030872,
          131.563693
        ],
        "alpha": 1,
        "hex": "#dae6d1"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.888356,
          0.038472,
          131.850046
        ],
        "alpha": 1,
        "hex": "#d1e0c6"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.863414,
          0.046179,
          132.075776
        ],
        "alpha": 1,
        "hex": "#c7d9ba"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.841479,
          0.053915,
          132.266749
        ],
        "alpha": 1,
        "hex": "#bed3af"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Gumleaf Green. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.819493,
          0.061704,
          132.440252
        ],
        "alpha": 1,
        "hex": "#b5cda4"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.779034,
          0.078008,
          131.716965
        ],
        "alpha": 1,
        "hex": "#a5c28e"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.738331,
          0.095363,
          131.14891
        ],
        "alpha": 1,
        "hex": "#95b777"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.698368,
          0.111626,
          130.536363
        ],
        "alpha": 1,
        "hex": "#86ac60"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Marshland Lime. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.658809,
          0.128909,
          129.573593
        ],
        "alpha": 1,
        "hex": "#78a146"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.597741,
          0.117755,
          135.435441
        ],
        "alpha": 1,
        "hex": "#5f8f44"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.53758,
          0.106753,
          140.785426
        ],
        "alpha": 1,
        "hex": "#497d40"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.474253,
          0.094245,
          146.68405
        ],
        "alpha": 1,
        "hex": "#346a3b"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Bushland Green. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.413248,
          0.083694,
          152.251293
        ],
        "alpha": 1,
        "hex": "#215834"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.33935,
          0.070824,
          152.299914
        ],
        "alpha": 1,
        "hex": "#154225"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.26844,
          0.058993,
          151.972747
        ],
        "alpha": 1,
        "hex": "#0a2e17"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette green. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.196299,
          0.047105,
          152.148349
        ],
        "alpha": 1,
        "hex": "#021b0a"
      }
    }
  },
  "nsw-aboriginal-blue": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.972229,
          0.01093,
          211.037673
        ],
        "alpha": 1,
        "hex": "#eef8fa"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.945717,
          0.019454,
          208.752559
        ],
        "alpha": 1,
        "hex": "#dff1f4"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.917212,
          0.027259,
          211.060105
        ],
        "alpha": 1,
        "hex": "#d0e9ee"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Coastal Blue. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.890786,
          0.035649,
          209.821304
        ],
        "alpha": 1,
        "hex": "#c1e2e8"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.864456,
          0.04392,
          209.064626
        ],
        "alpha": 1,
        "hex": "#b2dbe2"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.838252,
          0.052013,
          208.568033
        ],
        "alpha": 1,
        "hex": "#a3d4dc"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.810349,
          0.059652,
          211.082852
        ],
        "alpha": 1,
        "hex": "#94ccd7"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Light Water Blue. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.783944,
          0.068061,
          210.370892
        ],
        "alpha": 1,
        "hex": "#84c5d1"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.710807,
          0.075929,
          215.877035
        ],
        "alpha": 1,
        "hex": "#67aec0"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.635139,
          0.084359,
          223.003411
        ],
        "alpha": 1,
        "hex": "#4a96b0"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.562541,
          0.092877,
          229.710383
        ],
        "alpha": 1,
        "hex": "#2e7fa1"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Saltwater Blue. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.486814,
          0.101282,
          236.48206
        ],
        "alpha": 1,
        "hex": "#0d6791"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.453354,
          0.095261,
          236.711605
        ],
        "alpha": 1,
        "hex": "#095d84"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.419192,
          0.089257,
          236.915828
        ],
        "alpha": 1,
        "hex": "#055377"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.384348,
          0.083118,
          237.181984
        ],
        "alpha": 1,
        "hex": "#02496a"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Billabong Blue. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.352129,
          0.077132,
          237.212654
        ],
        "alpha": 1,
        "hex": "#00405e"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.29029,
          0.065293,
          238.901936
        ],
        "alpha": 1,
        "hex": "#002f48"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.231745,
          0.052298,
          239.104965
        ],
        "alpha": 1,
        "hex": "#002033"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette blue. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.169957,
          0.039922,
          241.439476
        ],
        "alpha": 1,
        "hex": "#00111f"
      }
    }
  },
  "nsw-aboriginal-purple": {
    "50": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.967122,
          0.013295,
          333.038378
        ],
        "alpha": 1,
        "hex": "#faf1f8"
      }
    },
    "100": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.935345,
          0.020206,
          330.657457
        ],
        "alpha": 1,
        "hex": "#f2e5f0"
      }
    },
    "150": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.902288,
          0.029739,
          330.945661
        ],
        "alpha": 1,
        "hex": "#ebd8e8"
      }
    },
    "200": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Dusk Purple. Step 200: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.871008,
          0.037705,
          331.394651
        ],
        "alpha": 1,
        "hex": "#e4cce0"
      }
    },
    "250": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 250: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.837696,
          0.047595,
          331.568409
        ],
        "alpha": 1,
        "hex": "#ddbfd8"
      }
    },
    "300": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.807413,
          0.057622,
          331.752813
        ],
        "alpha": 1,
        "hex": "#d7b3d1"
      }
    },
    "350": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.773962,
          0.067882,
          331.957196
        ],
        "alpha": 1,
        "hex": "#d0a6c9"
      }
    },
    "400": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Lilli Pilli Purple. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.742653,
          0.07745,
          331.484775
        ],
        "alpha": 1,
        "hex": "#c99ac2"
      }
    },
    "450": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 450: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.698899,
          0.083937,
          331.327494
        ],
        "alpha": 1,
        "hex": "#bd8bb6"
      }
    },
    "500": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple — part of the NSW Government Aboriginal colour palette, which reflects the history of Aboriginal people within NSW, rich in diversity of culture, tribes, landscapes and history. Step 500: mid-tone.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.654738,
          0.090602,
          331.227929
        ],
        "alpha": 1,
        "hex": "#b17caa"
      }
    },
    "550": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 550: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.611738,
          0.09918,
          331.125122
        ],
        "alpha": 1,
        "hex": "#a66d9f"
      }
    },
    "600": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Spirit Lilac. Step 600: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.566952,
          0.106118,
          331.144643
        ],
        "alpha": 1,
        "hex": "#9a5e93"
      }
    },
    "650": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 650: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.505299,
          0.096561,
          331.048693
        ],
        "alpha": 1,
        "hex": "#844f7e"
      }
    },
    "700": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 700: borders and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.444777,
          0.085629,
          331.74633
        ],
        "alpha": 1,
        "hex": "#6f4169"
      }
    },
    "750": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 750: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.383951,
          0.076245,
          332.607859
        ],
        "alpha": 1,
        "hex": "#5b3355"
      }
    },
    "800": {
      "$type": "color",
      "$description": "NSW Aboriginal palette Bush Plum. Step 800: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.323017,
          0.065535,
          332.719669
        ],
        "alpha": 1,
        "hex": "#472642"
      }
    },
    "850": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.265091,
          0.056272,
          332.687214
        ],
        "alpha": 1,
        "hex": "#351a31"
      }
    },
    "900": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.210078,
          0.044162,
          332.740798
        ],
        "alpha": 1,
        "hex": "#241021"
      }
    },
    "950": {
      "$type": "color",
      "$description": "NSW Aboriginal palette purple. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.153982,
          0.036034,
          334.855453
        ],
        "alpha": 1,
        "hex": "#150612"
      }
    }
  },
  "success": {
    "50": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.97135,
          0.019006,
          140.501237
        ],
        "alpha": 1,
        "hex": "#eff9ed"
      }
    },
    "100": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.944414,
          0.03435,
          142.617675
        ],
        "alpha": 1,
        "hex": "#e0f3de"
      }
    },
    "150": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.916251,
          0.047557,
          142.315326
        ],
        "alpha": 1,
        "hex": "#d2eccf"
      }
    },
    "200": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.888142,
          0.060884,
          142.11755
        ],
        "alpha": 1,
        "hex": "#c4e5c0"
      }
    },
    "250": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.831935,
          0.081627,
          142.168533
        ],
        "alpha": 1,
        "hex": "#aad6a5"
      }
    },
    "300": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.775209,
          0.103098,
          142.532525
        ],
        "alpha": 1,
        "hex": "#8fc78a"
      }
    },
    "350": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.716492,
          0.122642,
          142.635863
        ],
        "alpha": 1,
        "hex": "#74b76f"
      }
    },
    "400": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.660489,
          0.143002,
          142.833374
        ],
        "alpha": 1,
        "hex": "#58a854"
      }
    },
    "450": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.633907,
          0.153727,
          142.929021
        ],
        "alpha": 1,
        "hex": "#49a146"
      }
    },
    "500": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.604784,
          0.163709,
          142.769697
        ],
        "alpha": 1,
        "hex": "#399936"
      }
    },
    "550": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.57829,
          0.174808,
          142.795704
        ],
        "alpha": 1,
        "hex": "#259224"
      }
    },
    "600": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.549041,
          0.184944,
          142.800761
        ],
        "alpha": 1,
        "hex": "#008a07"
      }
    },
    "650": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.478504,
          0.161407,
          142.758807
        ],
        "alpha": 1,
        "hex": "#007204"
      }
    },
    "700": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.40526,
          0.136911,
          142.712023
        ],
        "alpha": 1,
        "hex": "#005a02"
      }
    },
    "750": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.335094,
          0.113301,
          142.686907
        ],
        "alpha": 1,
        "hex": "#004401"
      }
    },
    "800": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.26443,
          0.089979,
          142.495345
        ],
        "alpha": 1,
        "hex": "#002f00"
      }
    },
    "850": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.218312,
          0.074286,
          142.495345
        ],
        "alpha": 1,
        "hex": "#002200"
      }
    },
    "900": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.173455,
          0.059022,
          142.495345
        ],
        "alpha": 1,
        "hex": "#001600"
      }
    },
    "950": {
      "$type": "color",
      "$description": "Success state — positive outcomes, confirmations, and completed actions. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.1296,
          0.044099,
          142.495345
        ],
        "alpha": 1,
        "hex": "#000b00"
      }
    }
  },
  "warning": {
    "50": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.971893,
          0.01526,
          48.562489
        ],
        "alpha": 1,
        "hex": "#fff3ed"
      }
    },
    "100": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.946835,
          0.028629,
          45.030952
        ],
        "alpha": 1,
        "hex": "#ffe8de"
      }
    },
    "150": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.922108,
          0.042396,
          43.676216
        ],
        "alpha": 1,
        "hex": "#ffddcf"
      }
    },
    "200": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.895911,
          0.054446,
          43.945452
        ],
        "alpha": 1,
        "hex": "#fdd2c0"
      }
    },
    "250": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.843843,
          0.073851,
          43.908489
        ],
        "alpha": 1,
        "hex": "#f6bda5"
      }
    },
    "300": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.791422,
          0.092884,
          44.093664
        ],
        "alpha": 1,
        "hex": "#eea88a"
      }
    },
    "350": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.739959,
          0.112378,
          44.054533
        ],
        "alpha": 1,
        "hex": "#e6936f"
      }
    },
    "400": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.686894,
          0.13202,
          43.712861
        ],
        "alpha": 1,
        "hex": "#dd7d53"
      }
    },
    "450": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.660361,
          0.141466,
          43.83103
        ],
        "alpha": 1,
        "hex": "#d87244"
      }
    },
    "500": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.634409,
          0.150779,
          43.925238
        ],
        "alpha": 1,
        "hex": "#d36734"
      }
    },
    "550": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.609132,
          0.159967,
          44.109192
        ],
        "alpha": 1,
        "hex": "#ce5c21"
      }
    },
    "600": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.58333,
          0.169705,
          43.997259
        ],
        "alpha": 1,
        "hex": "#c95000"
      }
    },
    "650": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.507151,
          0.15026,
          42.423427
        ],
        "alpha": 1,
        "hex": "#a83f03"
      }
    },
    "700": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.431173,
          0.130695,
          40.89405
        ],
        "alpha": 1,
        "hex": "#882f03"
      }
    },
    "750": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.354963,
          0.110993,
          39.686374
        ],
        "alpha": 1,
        "hex": "#692001"
      }
    },
    "800": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.278045,
          0.090492,
          38.267541
        ],
        "alpha": 1,
        "hex": "#4b1200"
      }
    },
    "850": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.230061,
          0.077034,
          36.983064
        ],
        "alpha": 1,
        "hex": "#390a00"
      }
    },
    "900": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.18011,
          0.062518,
          35.437897
        ],
        "alpha": 1,
        "hex": "#270400"
      }
    },
    "950": {
      "$type": "color",
      "$description": "Warning state — caution and actions that need attention. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.132509,
          0.049077,
          32.856899
        ],
        "alpha": 1,
        "hex": "#170100"
      }
    }
  },
  "danger": {
    "50": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.966669,
          0.016317,
          22.079707
        ],
        "alpha": 1,
        "hex": "#fff0ef"
      }
    },
    "100": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.936228,
          0.032074,
          20.106519
        ],
        "alpha": 1,
        "hex": "#ffe2e1"
      }
    },
    "150": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.90654,
          0.04838,
          18.081137
        ],
        "alpha": 1,
        "hex": "#ffd4d4"
      }
    },
    "200": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.875232,
          0.062981,
          18.428147
        ],
        "alpha": 1,
        "hex": "#fdc6c6"
      }
    },
    "250": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.813013,
          0.084945,
          18.165704
        ],
        "alpha": 1,
        "hex": "#f4acad"
      }
    },
    "300": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.75077,
          0.106785,
          18.43901
        ],
        "alpha": 1,
        "hex": "#ea9294"
      }
    },
    "350": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.689178,
          0.12804,
          18.526045
        ],
        "alpha": 1,
        "hex": "#df787c"
      }
    },
    "400": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.62753,
          0.149171,
          18.309398
        ],
        "alpha": 1,
        "hex": "#d35d65"
      }
    },
    "450": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.596213,
          0.160938,
          18.339163
        ],
        "alpha": 1,
        "hex": "#cd4e59"
      }
    },
    "500": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.565284,
          0.170522,
          18.2478
        ],
        "alpha": 1,
        "hex": "#c63f4e"
      }
    },
    "550": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.532839,
          0.182017,
          18.232802
        ],
        "alpha": 1,
        "hex": "#bf2c42"
      }
    },
    "600": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.501996,
          0.192725,
          18.079135
        ],
        "alpha": 1,
        "hex": "#b81237"
      }
    },
    "650": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.436904,
          0.169068,
          18.82836
        ],
        "alpha": 1,
        "hex": "#990b2a"
      }
    },
    "700": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.374388,
          0.145685,
          19.336218
        ],
        "alpha": 1,
        "hex": "#7c061f"
      }
    },
    "750": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.30874,
          0.121759,
          19.939515
        ],
        "alpha": 1,
        "hex": "#5f0214"
      }
    },
    "800": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.244464,
          0.098267,
          20.667881
        ],
        "alpha": 1,
        "hex": "#44000a"
      }
    },
    "850": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.202838,
          0.081665,
          21.65418
        ],
        "alpha": 1,
        "hex": "#330005"
      }
    },
    "900": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.161611,
          0.065248,
          23.141473
        ],
        "alpha": 1,
        "hex": "#230002"
      }
    },
    "950": {
      "$type": "color",
      "$description": "Danger state — errors and destructive or critical actions. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.120777,
          0.048658,
          22.023968
        ],
        "alpha": 1,
        "hex": "#140001"
      }
    }
  },
  "info": {
    "50": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 50: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.947933,
          0.013249,
          262.378766
        ],
        "alpha": 1,
        "hex": "#e9eef7"
      }
    },
    "100": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 100: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.894885,
          0.02153,
          259.191552
        ],
        "alpha": 1,
        "hex": "#d4ddeb"
      }
    },
    "150": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 150: subtle backgrounds and surfaces.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.84226,
          0.030869,
          260.704222
        ],
        "alpha": 1,
        "hex": "#c0cce0"
      }
    },
    "200": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 200: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.788988,
          0.040588,
          261.491472
        ],
        "alpha": 1,
        "hex": "#acbbd5"
      }
    },
    "250": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 250: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.732279,
          0.055255,
          262.600626
        ],
        "alpha": 1,
        "hex": "#96a9cc"
      }
    },
    "300": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 300: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.676764,
          0.068234,
          261.470834
        ],
        "alpha": 1,
        "hex": "#8098c2"
      }
    },
    "350": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 350: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.619287,
          0.082332,
          262.339289
        ],
        "alpha": 1,
        "hex": "#6b86b8"
      }
    },
    "400": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 400: Interactive components.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.564226,
          0.095527,
          262.52779
        ],
        "alpha": 1,
        "hex": "#5775ae"
      }
    },
    "450": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 450: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.535493,
          0.102893,
          262.922919
        ],
        "alpha": 1,
        "hex": "#4d6ca9"
      }
    },
    "500": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 500: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.508435,
          0.109592,
          262.050185
        ],
        "alpha": 1,
        "hex": "#4264a4"
      }
    },
    "550": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 550: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.479149,
          0.115698,
          262.137071
        ],
        "alpha": 1,
        "hex": "#385b9e"
      }
    },
    "600": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 600: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.450622,
          0.123283,
          262.351496
        ],
        "alpha": 1,
        "hex": "#2e5299"
      }
    },
    "650": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 650: borders, separators and icons.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.390336,
          0.109632,
          262.276763
        ],
        "alpha": 1,
        "hex": "#23427f"
      }
    },
    "700": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 700: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.331327,
          0.095363,
          262.195822
        ],
        "alpha": 1,
        "hex": "#193366"
      }
    },
    "750": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 750: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.274244,
          0.081954,
          262.38017
        ],
        "alpha": 1,
        "hex": "#10254f"
      }
    },
    "800": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 800: Solid colors.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.213923,
          0.06809,
          262.409405
        ],
        "alpha": 1,
        "hex": "#071738"
      }
    },
    "850": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 850: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.177247,
          0.057971,
          262.994032
        ],
        "alpha": 1,
        "hex": "#040f2a"
      }
    },
    "900": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 900: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.137795,
          0.047857,
          264.580497
        ],
        "alpha": 1,
        "hex": "#02071c"
      }
    },
    "950": {
      "$type": "color",
      "$description": "Informational state — neutral highlights, tips, and in-progress notices. Step 950: text and high emphasis.",
      "$value": {
        "colorSpace": "oklch",
        "components": [
          0.101112,
          0.036894,
          257.665016
        ],
        "alpha": 1,
        "hex": "#00030f"
      }
    }
  },
  "white": {
    "$type": "color",
    "$description": "Pure white — page backgrounds, content surfaces, and text on dark or solid fills.",
    "$value": {
      "colorSpace": "oklch",
      "components": [
        1,
        0,
        "none"
      ],
      "alpha": 1,
      "hex": "#ffffff"
    }
  },
  "black": {
    "$type": "color",
    "$description": "Pure black — maximum-contrast text, overlays, and scrims.",
    "$value": {
      "colorSpace": "oklch",
      "components": [
        0,
        0,
        "none"
      ],
      "alpha": 1,
      "hex": "#000000"
    }
  }
}
